import {DropdownButton, MenuItem} from 'react-bootstrap';
import React from 'react';
import formatNumbers  from 'util/formatNumbers';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';
import ConfirmModalDialog from'shared/ConfirmModalDialog';
import json2csv   from 'json2csv'
import config from  '../../config';
import _ from "lodash";
import classNames from 'classnames'
import moment from 'moment'
import MDHistory from 'react-icons/lib/md/history';
import {Link} from 'react-router';

import FaClose from 'react-icons/lib/fa/close';

var async = require('async');
export function prepareSelectOptionsList(data, fieldsMap) {
    return _.reduce(data, function (optionList, item) {

        var option ={'value': item[fieldsMap['value']], 'label':typeof fieldsMap['label'] == 'function' ? fieldsMap['label'](item) : item[fieldsMap['label']]}
        if (!_.isUndefined(fieldsMap['customOptionFields'])) {
            _.forEach(fieldsMap['customOptionFields'], function (customField) {
                 option[customField.fieldName] =  _.get(item,customField['path'])

            })
         }
        optionList.push(option);
        return optionList;
    }, []);
}




export function matchSKU(SKU, params={maxDigitsNumber:3}){
    SKU = SKU.replace(/\n+$/, "") /* replace all last new line character*/
    if(params.maxDigitsNumber ==3){
        return SKU.match(/^(\d+\.\d+\.\d+)(-[a-z0-9]*)?$/i)
    }else if(params.maxDigitsNumber ==4){
        return SKU.match(/^(\d+\.\d+\.\d+)(\.(\d+))?(-[a-z0-9]*)?$/i)
    }
}
export function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export function filterFocusAreaOptions(focusAreas, ageGroupsMap) {
    var filteredTags = _.reduce(focusAreas, function (focusAreas, tag) {
        if (_.size(ageGroupsMap) > 0) {
            if (_.size(_.intersection(tag.AgeCategories, ageGroupsMap)) > 0) {
                focusAreas.push({'value': tag.Name, 'label': tag.Name});
            }
        } else {
            focusAreas.push({'value': tag.Name, 'label': tag.Name});
        }
        return focusAreas;
    }, []);
    return filteredTags
}

export function filterFocusAreaSelectedOptions(focusAreas, ageGroupsMap, selectedTags) {
    var filteredSelectedTags = _.reduce(selectedTags, function (filteredSelectedTags, selectedTag) {
        var focusAreaOriginal = _.find(focusAreas, function (o) { /* find selected tag in original array */
            return o.Name === selectedTag.value;
        });
        if (!_.isUndefined(focusAreaOriginal) && _.size(_.intersection(focusAreaOriginal.AgeCategories, ageGroupsMap))) {
            filteredSelectedTags.push(selectedTag);
        }
        return filteredSelectedTags;
    }, []);
    return filteredSelectedTags
}
export function validateEmail(email) {
    var re = /^(([^<>()[\]\,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* original     var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;  this does not allow emails like email.@gmail.com */

    return re.test(email);
}
export function removePrefix(string, prefix) {
    string = _.trim(string)
    return string.startsWith(prefix) ? string.slice(prefix.length) : string
}
export function dateFormatter(cell, row, extra) {
    if (_.isUndefined(extra.path)) {
        if (_.isUndefined(row[extra.name]) || !row[extra.name]) {
            return '';
        } else {
            return moment(row[extra.name]).format(extra.format);
        }
    } else {

        if (!_.get(row, extra.path)) {
            return '';
        } else {
            return moment(_.get(row, extra.path, '')).format(extra.format);
        }

    }

}
export function priceFormatter(cell, row, extra) {
    let price = _.isUndefined(row[extra.path]) ?  '' : row[extra.path];
    return formatNumbers.formatMoney(price, {precision:price % 1 == 0 ? 0 : 2});
}
export function customFormatter(cell, row, extra) {
    if (extra.path == 'getObject'){
        return extra.format(row)
    } else {
        return extra.format(_.get(row, extra.path, ''), _.get(row, _.get(extra, ['path2'], 'path2_not_available'), undefined))
    }
}
export function  convertToHoursAndMinutes(duration, params) {
    if (params.format == 'hours_and_minutes') {
        return Math.floor(duration.asHours())== 0 ? (duration.minutes() + ' ' + (duration.minutes() == 1 ? 'minute' : 'minutes')): ((Math.floor(duration.asHours())  + ' ' + (Math.floor(duration.asHours()) == 1 ? 'hour' : 'hours')) + ' and ' + duration.minutes() + ' ' + (duration.minutes() == 1 ? 'minute' : 'minutes'))
    } else if (params.format == 'hours_minutes_seconds') {
        var data =''
        if ( Math.floor(duration.asHours()) >0){
            data = Math.floor(duration.asHours()) + ' h '
        }
        if (duration.minutes()){
            data += duration.minutes() + ' min '
        }
        if (duration.seconds()){
            data += duration.seconds() + ' sec'
        }
        return data
    }else  if (params.format == 'h:m') {
        return Math.floor(duration.asHours()) + 'h  '+  duration.minutes() +'m'

    }else  if (params.format == 'h m') {
        return Math.floor(duration.asHours()) + ' h  '+  duration.minutes() +' m'

    }else if (params.format == 'hrs:min') {
        return Math.floor(duration.asHours()) + ' hrs  '+  duration.minutes() +' min'

    }else  if (params.format == 'hours') {
        return Math.floor(duration.asHours()) + (Math.floor(duration.asHours()) == 1 ? ' hour':' hours')

    }else if (params.format == 'days') {
      return  Math.floor(duration.asDays()) + (Math.floor(duration.asDays()) == 1 ? ' day':' days')

    }else if (params.format == 'minutes_in_percentage') {
         return  formatNumbers.toFixed(Math.floor(duration.asHours()) + (duration.minutes() / 60), 2)

    }
}
export function modifyStringFormatter(cell, row, extra) {
    if (extra.action == 'append') {
        return (_.get(row, extra.path, '') + extra.value)
    }
}
export function downloadCustomReport() {
    var allReportFieldList = [
        {label: 'ID', value:'ID'},
        {label: 'Brand', value:'Brand'},
        {label: 'Model', value:'Model'},
        {label: 'Width', value:'Width'},
        {label: 'Length', value:'Length'},
        {label: 'Height', value:'Height'},
         {label: 'Box Size', value:'BoxSize'},
        {label: 'Note', value:'GBGNote'},
        {label: 'Tags', value:'GBGProductTags'},
        {label: 'Categories', value:'Categories'},
         {label: 'Variations', value:'Variations'},

 ]
    var methodData = {
        "endpoint": "/create-report",
        'type': 'post',
        timeout:250000,
        'not_display_success_message': true,
        overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
    };
    var queryParams = {reportType: 'customReport'}
    this.props.makeRequest(queryParams, methodData).then(res => {
        var fields = _.map(allReportFieldList, function (field) {
            return _.extend({}, field, {default: ''});
        })

        var dataToExport = _.map(res.data, function (record) {
            return _.extend(record, {
                'Variations':_.get(record,  'Variations', []).length ? record.Variations:'',

                'Categories':_.get(record,  'Categories', []).length ? record.Categories:'',
              'GBGProductTags':_.get(record,  'GBGProductTags', []).length ? record.GBGProductTags:'',

             })
        })
        var csvData = json2csv.parse(dataToExport, {
            fields: fields,
            unwindPath: 'UserID'
        })

            var filename = "report_" + moment().format("YYYY-MM-DD-HH-mm") + ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

    }).catch(err => {
        console.log('err', err);
    });
};
export function linkFormatter(cell, row, extra) {

    var pathValue = _.get(row, extra.path, '')
    if (extra.formatPathValue) {
        pathValue = customFormatter(cell, row, {
            format: extra.formatPathValue,
            path: extra.path
        })
    }

    var label = _.get(row, extra.labelPath, extra.label ? extra.label : 'Link')
     if (extra.getLabel){
        label  =extra.getLabel(row)
    }
        if (pathValue) {
        return  <a target="_blank" style={_.get(extra, 'linkStyle',{})}
               href={extra.template.replace(extra.placeholder, pathValue)}>{label} </a>
    } else {
        return <div>{label} </div>
    }
 }
 export function  loadScript(src) {

     var script = document.createElement('script');
     script.async = false;
     script.src = src;
     document.body.appendChild(script);
 }
export function isIsoDate(str) {
    if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
    var d = new Date(str);
    return d.toISOString()===str;
}
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
export function historyDataFormatter(row, params) {
    if (_.size(_.get(row, [params.field], [])) > 0) {

        return (
            <Link className="cursor-pointer" onClick={() => this.setState({
                currentRecord: _.extend({}, row, {currentField: params.field, modalTitle: _.get(params, 'modalTitle')}),
                historyDataModalVisible: true
            })}
            ><MDHistory style={{fontSize: 28}}></MDHistory></Link>
        );
    } else {
        return null;
    }
}
export function  imagesFormatter( row, rowIndex,  extra) {

    if (_.get(row, extra.imagePath, false)) {
        var lastRow = false;
         if (_.ceil(extra.total /  extra.perPage) == extra.currentPage+1){/* check if it is the last page */
            if (extra.total > extra.perPage){/* if there are more than one page */
                if (extra.total % extra.perPage == rowIndex+1){
                    lastRow = true;
                }
            } else  if (extra.total  == rowIndex+1){
                lastRow = true;
            }
        }
         if (extra.displayMultipleImages){
            return <div>
                {_.map(_.get(row, extra.imagePath),  (image,index)=> {
                    if (!image.URL) {
                        return <div></div>;
                    }
                    const imageId = image._id || image.id
                    return <div   key={`${imageId} ${index}`} className={classNames( 'image-wrapper --multiple-images', {'first-or-last-row':  rowIndex == 0 || rowIndex==(extra.perPage-1)  || lastRow ? true:false}, {'first-row':  rowIndex == 0 ? true:false}, { 'enlarged' : this.state.activeImageID === imageId })}
                                onClick={() => {
                                    changeSelectedImageID.call(this, imageId)
                                }}>
                        <img style={extra.imageStyle || {}}  title={_.get(image, extra.imageTitlePath,'')}  src={formatImageForBucket(image.URL)} />
                        {!_.isUndefined(extra.deleteImageHandler) &&
                          <FaClose   onClick={(e) => {
                              e.stopPropagation()
                              extra.deleteImageHandler.call(this, image)
                          }} style={{color: 'red'}} className="delete-button text-center"></FaClose>
                        }
                    </div>;
                })}</div>
        } else {
            return <div
                className={classNames('image-wrapper --multiple-images', {'first-or-last-row': rowIndex == 0 || rowIndex == (extra.perPage - 1) || lastRow ? true : false}, {'enlarged': this.state.activeImageID === _.get(row, extra.imagePath)})}
                onClick={() => {
                    changeSelectedImageID.call(this, _.get(row, extra.imagePath))
                }}>
                <img style={extra.imageStyle || {}} title={_.get(row, extra.imageTitlePath,'')}  src={formatImageForBucket(_.get(row, extra.imagePath)) }/>
            </div>;
        }
    } else{
        return ''
    }
}
function changeSelectedImageID( id) {
    // if (this.timeout) {
    //     clearTimeout(this.timeout)
    // }
    console.log('id',id );
    if (this.state.activeImageID ===  id) {
        return this.setState({
            activeImageID: ''
        })
    }
    return this.setState({
        activeImageID: id,
    }, () => {

        // this.timeout = setTimeout(() => this.setState({
        //     activeImageID: ''
        // }), 5000)
    })
}
export function deleteImagesFromS3(imagesToDelete) {
    console.log('deleteImagesFromS3', imagesToDelete  );
    return new Promise((resolve, reject) => {
        var self = this;
        var functionsToCall = [];
        _.forEach(imagesToDelete, function (imageURL, key){
            functionsToCall.push(function (done) {
                 self.props.makeRequest({
                    fileURL: imageURL
                }, {
                    'endpoint': '/delete-s3-file',
                    'not_display_success_message': true,
                    'not_display_error_message': true,
                    'type': 'post',
                }).then(function () {
                    done(null)
                }).catch(function (err) {
                    done(err)
                })
            });
        })
        async.parallel(functionsToCall,
          function (err, uploadResponses) {
              if (err) {
                  self.props.displayMessage({
                      'messageCode': 'Something went wrong. Image was not deleted from S3'
                  });
                  return reject(err)
              }
              resolve(true)
          });
    })
}
export function displayCustomDialog(params) {

    return <ConfirmModalDialog
        buttonTitle={_.get(params, 'buttonTitle', '')}
        secondButtonTitle={_.get(params, 'secondButtonTitle')}
        cancelButtonTitle={_.get(params, 'cancelButtonTitle')}
        show={ this.state['show' + params.dialogID]}
        dialogContent={_.get(params, 'dialogContent')}
        title={_.get(params, 'modalTitle', '')}
        cancelActionHandler={_.get(params, 'cancelActionHandler')}
        confirmActionHandler={(data) => {
            this.setState({
                ['show' + params.dialogID]: false,
            }, function () {
                params.confirmActionHandler(data)
            })
        } }

        closeModal={(e) => this.setState({
            ['show' + params.dialogID]: false,
        })}>
    </ConfirmModalDialog>
}
export function generateMongoObjectID() {
    var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
            return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase();
};
export function actionsFormatter(cell, row, extra) {
    if (_.isArray(extra.menuItemsMap)) {
        var menuItemsList = extra.menuItemsMap;
    } else {
        var currentItem = _.isUndefined(extra.rowField) ? extra.currentItem : row[extra.rowField];
        var menuItemsList = extra.menuItemsMap[currentItem];
    }
    var menuItems = menuItemsList.map((item, itemID) => {
            // console.log('this[item.onClick].bind(this, row)', this[item.onClick].bind(this, row));

            return (<MenuItem key={itemID} eventKey={itemID} className={_.get(item, 'customMenuItemClass',{})}
                              onClick={ typeof item.onClick === "string" ? this[item.onClick].bind(this, row) : item.onClick.bind(this, row) }>{item.label}</MenuItem>)
        }
    );

    return _.size(menuItemsList) == 0 ? null : (
        <DropdownButton bsStyle="default" pullRight
                     //  className={_.get(extra, 'buttonClass','')}
            //  onClick={e => dropdownPosition(e)}
                        title={ <span className={_.get(extra, 'buttonIconClass','glyphicon glyphicon-cog')}/>} noCaret key={row.Id}
                        id="dropdown-basic-default">
            {menuItems}
        </DropdownButton>
    );
}


export function onAllRowSelect(isSelected, rows) {
    var rowIDs = _.map(rows, '_id')
    if (isSelected) {
        this.setState({recordIDs: _.uniq(this.state.recordIDs.concat(rowIDs))})
    } else {
        this.setState({recordIDs: _.difference(this.state.recordIDs, rowIDs)})
    }
}
export function onRowSelect(row, isSelected, e) {
    if (isSelected) {
        this.setState({recordIDs: this.state.recordIDs.concat([row._id])})
    } else {
        this.setState({recordIDs: _.pull([...this.state.recordIDs], row._id)})
    }
}
export function customMultiSelect(props) {
        return customTableSelect(props, {
        table: _.get(this.refs, 'table.tableRef') ? this.refs.table.tableRef : undefined,
        selectedRows: this.state.recordIDs,
    });
}


export function customTableSelect(props, customData) {
     if (!_.isUndefined(customData.table)) {
        var rowIDs = _.map(customData.table.state.data, function (row, key) {
            return row._id;
        });
    }
     var {type, checked, disabled, onChange, rowIndex} = props;
    if (!_.isUndefined(rowIDs) && rowIndex !== 'Header') {
        checked = _.includes(customData.selectedRows, rowIDs[rowIndex])
    }

    /*
     * If rowIndex is 'Header', means this rendering is for header selection column.
     */
     if (rowIndex === 'Header') {

        return (
            <div className='checkbox-personalized'>
                <CustomTableHeaderCheckbox { ...props }/>
                <label htmlFor={ 'checkbox' + rowIndex }>
                    <div className='check'></div>
                </label>
            </div>);
    } else {
        return (
            <div className='checkbox-personalized'>
                <input
                    type={ type }
                    name={ 'checkbox' + rowIndex }
                    id={ 'checkbox' + rowIndex }
                    checked={ checked }
                    disabled={ disabled }
                    onChange={ e => onChange(e, rowIndex) }
                />
                <label htmlFor={ 'checkbox' + rowIndex }>
                    <div className='check'></div>
                </label>
            </div>);
    }
}

export function formatImageForBucket(url){
    let urlString = url.toString();
    let regExpOldBucket = RegExp(`^${config.getEnvironment().amazon.s3BucketOldURL}`)
    
    if(urlString.match(regExpOldBucket)){
        let urlWithoutBucket = url.toString().replace(regExpOldBucket,"")
        let bucketURL = config.getEnvironment().amazon.s3BucketURL
        return `${bucketURL}${urlWithoutBucket}`
    }
    
    return urlString;
}

export function hexToBase64(hexstring) {
    return btoa(hexstring.match(/\w{2}/g).map(function(a) {
        return String.fromCharCode(parseInt(a, 16));
    }).join(""));
}
export function base64ToHex(base64,params={}) {

    var raw = atob(base64);

    var HEX = '';

    for (var i = 0; i < raw.length; i++) {

        var _hex = raw.charCodeAt(i).toString(16)

        HEX += (_hex.length == 2 ? _hex : '0' + _hex);

    }
    if(params.convertToHEXUUID){
        return HEX.toUpperCase().replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, function () {
            return arguments[1] + "-" + arguments[2] + "-" + arguments[3] + "-" + arguments[4] + "-" + arguments[5];
        });
    }
    return HEX.toUpperCase();

}

export function getFieldByPathFormatter(cell, row, extra) {
    return _.get(row, extra.path, (extra.path2 ? _.get(row, extra.path2,''):''));
}
